import { render } from "./ClientDemoInfo.vue?vue&type=template&id=12b19a0e&scoped=true"
import script from "./ClientDemoInfo.vue?vue&type=script&lang=js"
export * from "./ClientDemoInfo.vue?vue&type=script&lang=js"

import "./ClientDemoInfo.vue?vue&type=style&index=0&id=12b19a0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b19a0e"]])

export default __exports__